import React, { useEffect, useState } from "react";
import { GoogleAPIKey } from "../../api/UserApi";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { mapOptions } from "./constants";
import useWindowSize from "../../hooks/useWindowSize";
import "./index.css";

export default function MapViewer({
  productsWithAddress,
  setHoveredLocation,
  initialZoom,
}) {
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(null);
  const [productCoordinates, setProductCoordinates] = useState([]);
  const width = useWindowSize().width;

  const getHeight = (width) => {
    if (width > 768) return "50vh";
    return "30vh";
  };

  const getProductAddresses = (productsWithAddress) => {
    const productCoordinates = productsWithAddress.map((product) => {
      const { lat, lng } = product.address.value.geometry.location;
      return { id: product.id, title: product.caption, lat: lat, lng: lng };
    });
    return productCoordinates;
  };

  const fitMapToBounds = (map, productCoordinates) => {
    // Calculate the bounding box that encompasses all markers
    const bounds = new window.google.maps.LatLngBounds();
    productCoordinates.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));

    // Fit the map to the bounding box - Note: this affects zoom level
    if (initialZoom) map.setZoom(initialZoom);
    else map.fitBounds(bounds);

    // Get the center of the bounding box
    const center = bounds.getCenter();
    setCenter({ lat: center.lat(), lng: center.lng() });
  };

  useEffect(() => {
    const coordinatesArray = getProductAddresses(productsWithAddress);
    setProductCoordinates(coordinatesArray);
  }, [productsWithAddress]);

  useEffect(() => {
    if (map && productCoordinates.length > 0) {
      fitMapToBounds(map, productCoordinates);
    }
  }, [map, productCoordinates]);

  return (
    <section className="map-viewer">
      <div className="map-viewer__container">
        {/* TODO: Google warning: "JavaScript API has been loaded directly without
        loading=async. This can result in suboptimal performance." Potential fix:
        https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package */}
        <LoadScript googleMapsApiKey={GoogleAPIKey}>
          <GoogleMap
            options={mapOptions}
            mapContainerStyle={{
              height: getHeight(width),
              width: "100%",
            }}
            center={center}
            onLoad={(map) => setMap(map)}
          >
            {productCoordinates.map((markerObj, i) => (
              <Marker
                key={i}
                position={markerObj}
                title={markerObj.title}
                onMouseOver={() =>
                  setHoveredLocation &&
                  setHoveredLocation({ ...markerObj, slideIndex: i })
                }
                onClick={() =>
                  setHoveredLocation &&
                  setHoveredLocation({ ...markerObj, slideIndex: i })
                }
              />
            ))}
          </GoogleMap>
        </LoadScript>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/MapViewer/index.js